import { INTEGER_VALIDATION_RULE } from '@med-fe/util';

export const vehConfig = {
  teleOptometry: {
    label: 'Tele-optometry',
    type: 'checkbox',
  },
  vehStatus: {
    label: 'VEH Status',
    isVisible: true,
    type: 'select',
    data: [{ id: 'Live' }, { id: 'Hold' }, { id: 'VEH Removed' }],
    allowClear: true,
  },
  numberOfEquippedLanes: {
    label: 'Number of Equipped Lanes',
    isVisible: true,
    rules: [INTEGER_VALIDATION_RULE],
  },
  numberOfEquippedPretest: {
    label: 'Number of Equipped Pretest',
    isVisible: true,
    rules: [INTEGER_VALIDATION_RULE],
  },
  coverageModel: {
    label: 'Coverage Model',
    isVisible: true,
    type: 'select',
    data: [{ id: 'VEH Only' }, { id: 'Side-by-Side' }, { id: 'Combination' }],
    allowClear: true,
  },
  vehGoLive: {
    label: 'VEH Go Live',
    isVisible: true,
    type: 'date',
    allowClear: true,
  },
  vehLastDay: {
    label: 'VEH Last Day',
    isVisible: true,
    type: 'date',
    allowClear: true,
  },
  vehSystem: {
    label: 'VEH System',
    isVisible: true,
    type: 'select',
    data: [{ id: 'DigitalOptometrics' }, { id: 'VisionX' }],
    allowClear: true,
  },
  doctorNetwork: {
    label: 'Doctor Network',
    isVisible: true,
    type: 'select',
    data: [{ id: 'Open Network' }, { id: 'Combination' }],
    allowClear: true,
  },
  phoropterEquipment: {
    label: 'Phoropter Equipment',
    isVisible: true,
    type: 'select',
    data: [{ id: 'Marco' }, { id: 'Reichert' }],
    allowClear: true,
  },
  slitLampEquipment: {
    label: 'Slit-Lamp Equipment',
    isVisible: true,
    type: 'select',
    data: [{ id: 'DSC' }, { id: 'Firefly' }, { id: 'Other' }],
    allowClear: true,
  },
  slitLampEquipmentOther: {
    label: 'Slit-Lamp Equipment (Other)',
    isVisible: true,
    type: 'input',
    showWhen: { field: 'slitLampEquipment', value: 'Other' },
  },
  preTestEquipment: {
    label: 'Pre Test Equipment',
    isVisible: true,
    type: 'select',
    data: [{ id: 'Eyekinetix' }, { id: 'Heru' }, { id: 'Other' }],
    allowClear: true,
  },
  preTestEquipmentOther: {
    label: 'Pre Test Equipment (Other)',
    isVisible: true,
    type: 'input',
    showWhen: { field: 'preTestEquipment', value: 'Other' },
  },
};
